// extracted by mini-css-extract-plugin
export default {"btn":"LuminairesLink_btn__0VBlu"};